import React from 'react';
import { Input, Button, Space, DatePicker, Row, Col, Typography } from 'antd';
import { TaskPriority } from '../../ProfitScenario/types';
import dayjs, { Dayjs } from 'dayjs';

const { Text } = Typography;

interface TaskInputProps {
    newTaskContent: string;
    setNewTaskContent: (content: string) => void;
    newTaskPriority: TaskPriority;
    setNewTaskPriority: (priority: TaskPriority) => void;
    newTaskStartDate?: string;
    setNewTaskStartDate: (date: string | undefined) => void;
    newTaskEndDate?: string;
    setNewTaskEndDate: (date: string | undefined) => void;
    handleAddTask: () => void;
    onCancel: () => void;
    priorityConfig: Record<TaskPriority, { color: string; label: string }>;
}

export const TaskInput: React.FC<TaskInputProps> = ({
    newTaskContent,
    setNewTaskContent,
    newTaskPriority,
    setNewTaskPriority,
    newTaskStartDate,
    setNewTaskStartDate,
    newTaskEndDate,
    setNewTaskEndDate,
    handleAddTask,
    onCancel,
    priorityConfig
}) => {
    const canSubmit = newTaskContent.trim() && newTaskStartDate && newTaskEndDate;

    const handleSubmit = () => {
        if (!newTaskContent.trim()) {
            return;
        }
        if (!newTaskStartDate || !newTaskEndDate) {
            return;
        }
        handleAddTask();
    };

    return (
        <div style={{ marginTop: 8, padding: '8px', background: '#f5f5f5', borderRadius: 4 }}>
            <Input
                size="small"
                placeholder="输入任务内容..."
                value={newTaskContent}
                onChange={e => setNewTaskContent(e.target.value)}
                onPressEnter={handleSubmit}
                autoFocus
                style={{ marginBottom: 8 }}
                prefix={
                    <select
                        value={newTaskPriority}
                        onChange={e => setNewTaskPriority(e.target.value as TaskPriority)}
                        style={{
                            border: 'none',
                            outline: 'none',
                            fontSize: 11,
                            color: priorityConfig[newTaskPriority].color,
                            background: 'transparent',
                            cursor: 'pointer'
                        }}
                    >
                        <option value="high">高</option>
                        <option value="medium">中</option>
                        <option value="low">低</option>
                    </select>
                }
            />

            <Row gutter={8} style={{ marginBottom: 4 }}>
                <Col span={12}>
                    <DatePicker
                        size="small"
                        format="YYYY-MM-DD"
                        placeholder="起始日期 *"
                        value={newTaskStartDate ? dayjs(newTaskStartDate) : undefined}
                        onChange={(date: Dayjs | null) => {
                            setNewTaskStartDate(date ? date.format('YYYY-MM-DD') : undefined);
                        }}
                        style={{
                            width: '100%',
                            borderColor: !newTaskStartDate ? '#ff4d4f' : undefined
                        }}
                        status={!newTaskStartDate ? 'error' : undefined}
                    />
                </Col>
                <Col span={12}>
                    <DatePicker
                        size="small"
                        format="YYYY-MM-DD"
                        placeholder="结束日期 *"
                        value={newTaskEndDate ? dayjs(newTaskEndDate) : undefined}
                        onChange={(date: Dayjs | null) => {
                            setNewTaskEndDate(date ? date.format('YYYY-MM-DD') : undefined);
                        }}
                        style={{
                            width: '100%',
                            borderColor: !newTaskEndDate ? '#ff4d4f' : undefined
                        }}
                        status={!newTaskEndDate ? 'error' : undefined}
                    />
                </Col>
            </Row>

            {(!newTaskStartDate || !newTaskEndDate) && (
                <Text type="danger" style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>
                    * 起始日期和结束日期为必填项
                </Text>
            )}

            <Space>
                <Button
                    size="small"
                    type="primary"
                    onClick={handleSubmit}
                    disabled={!canSubmit}
                >
                    确认
                </Button>
                <Button size="small" onClick={onCancel}>
                    取消
                </Button>
            </Space>
        </div>
    );
};
